import { z } from "zod";
import { InductionLocaleSchema } from "./induction-locale";

export const SiteInductionAcknowledgementSchema = z
  .object({
    projectId: z.string(),
    siteFieldsHash: z.string(),
    acknowledgedAt: z.string().datetime(),
    // Language the worker was shown at acknowledgement time (issue #991).
    // Absent/null on legacy rows and English acknowledgements.
    locale: InductionLocaleSchema.nullish(),
  })
  .strict();

export type SiteInductionAcknowledgement = z.infer<
  typeof SiteInductionAcknowledgementSchema
>;
